import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { customTabStyles, tabContentStyles } from "./styles";

const CustomTabs = (props) => {
  const {
    tabs,
    defaultTab = 0,
    centered = false,
    variant = "standard",
    orientation = "horizontal",
    onChange,
    tabStyles,
    tabPanelStyles,
    mainContainerStyles,
  } = props;
  const [value, setValue] = useState(defaultTab);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        ...mainContainerStyles,
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "#EAEAEA" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          centered={centered}
          variant={variant}
          orientation={orientation}
          aria-label="Global tabs"
          sx={{ ...customTabStyles, ...tabStyles }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              icon={tab.icon}
              disabled={tab.disabled}
              iconPosition="start"
              aria-controls={`tabpanel-${index}`}
              id={`tab-${index}`}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <Box
          key={index}
          role="tabpanel"
          hidden={value !== index}
          id={`tabpanel-${index}`}
          aria-labelledby={`tab-${index}`}
          sx={{ ...tabContentStyles, ...tabPanelStyles }}
        >
          {value === index && tab.content}
        </Box>
      ))}
    </Box>
  );
};

export default CustomTabs;
